import React from "react";
import { LegalLayout, LegalSection, LegalTable } from "../components/LegalLayout";
import { COMPANY } from "../lib/constants";
import { PLANS, inr } from "../config/pricing";

const SETUP_LINE = `One-time setup fee (${PLANS.map((p) => `${inr(p.setup)} ${p.name}`).join(" · ")})`;

const SECTIONS = [
  { id: "table", label: "What is refundable" },
  { id: "how-to-cancel", label: "How to cancel" },
  { id: "how-paid", label: "How refunds are paid" },
  { id: "hospital-payments", label: "Payments made to hospitals" },
  { id: "cmh", label: "Atikxzio CMH" },
  { id: "disputes", label: "Questions or disputes" },
];

const ROWS = [
  [SETUP_LINE, "Before onboarding starts (no configuration, migration or training done)", "100%"],
  ["One-time setup fee", "After onboarding has started", "Not refundable"],
  ["Monthly plan", "Within 7 days of your first go-live", "That month's plan fee, in full"],
  ["Monthly plan", "Any later time", "No refund for the current month; service runs to the end of the paid month, no further charges"],
  ["Annual plan", "Any time", "Unused full months at the monthly list price are refunded; the setup fee waived for annual payment is deducted from the refund"],
  ["IPD patient-day / Day Care usage charges", "—", "Not refundable once the day or session has been counted"],
  ["Purchased credits", "On closing your account", "Unused balance, minus GST already paid to the government"],
  ["Add-ons (PM-JAY Claim Kit, NABH Ready)", "Any time", "Stops at the end of the paid month; no refund for the current month"],
  ["Duplicate or failed payment (money debited, no invoice issued)", "Any time", "100%, automatically"],
];

export default function RefundPolicy() {
  return (
    <LegalLayout
      title="Refund &amp; Cancellation Policy"
      sections={SECTIONS}
      seo={{
        title: "Refund & Cancellation Policy | Priyajit Systems Private Limited",
        description: "Cancel any time. What is refundable for Atikxzio HMS setup fees, monthly and annual plans, usage charges, credits and add-ons, and how refunds are paid within 7 working days.",
      }}
    >
      <p className="text-[17px] leading-[1.75] text-slate-700">
        You can cancel any time; refunds depend on what was paid for and whether the work has started.
      </p>

      <LegalSection id="table" heading="What is refundable">
        <LegalTable head={["What you paid for", "Cancel when", "Refund"]} rows={ROWS} testId="refund-table" />
      </LegalSection>

      <LegalSection id="how-to-cancel" heading="How to cancel.">
        <p>Email {COMPANY.email} from the Owner's registered email, or use Settings in Atikxzio HMS. We confirm in writing within 2 working days.</p>
      </LegalSection>

      <LegalSection id="how-paid" heading="How refunds are paid.">
        <p>Approved refunds are processed within 7 working days, to the original payment method. Your bank or card issuer may take a further 5 to 7 working days to credit it. A GST credit note is issued with every refund.</p>
      </LegalSection>

      <LegalSection id="hospital-payments" heading="Payments made to hospitals.">
        <p>When a patient pays a hospital for a consultation, booking or bill, the money goes to that hospital. Refunds for those payments are decided and issued by the hospital under its own policy. The Atikxzio Pay convenience fee on an online booking is refunded only if the hospital cancels the booking.</p>
      </LegalSection>

      <LegalSection id="cmh" heading="Atikxzio CMH.">
        <p>Not yet on sale. A separate refund rule will be published here before launch.</p>
      </LegalSection>

      <LegalSection id="disputes" heading="Questions or disputes.">
        <p>{COMPANY.email} or {COMPANY.phone}. Unresolved issues can go to our Grievance Officer: {COMPANY.grievanceName}, {COMPANY.grievanceEmail}.</p>
      </LegalSection>
    </LegalLayout>
  );
}
